import * as React from 'react';
import { Link } from 'react-router-dom';


/**
 * Explicit "access denied" view shown when the current user is authenticated
 * but lacks the permission required for the requested page. This replaces the
 * previous silent redirect/blank render so the reason is clear to the user.
 */
const AccessDenied: React.FC = () => {
  return (
    <div
      className="access-denied"
      style={{ padding: '2rem', textAlign: 'center' }}
    >
      <h2>Access Denied</h2>
      <p>
        You do not have permission to view this page. If you believe this is a
        mistake, contact your administrator to have the required permission
        granted to your role.
      </p>
      <p style={{ marginTop: '0.5rem', color: '#888' }}>
        Note: newly granted permissions take effect after you sign out and sign
        back in.
      </p>
      <Link to="/Dashboard" className="btn btn-primary" style={{ marginTop: '1rem' }}>
        Return to Dashboard
      </Link>
    </div>
  );
};

export default AccessDenied;
